/* eslint no-console:0 */

import 'controllers'

import 'css/articles'
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/modal'
import $ from 'jquery'
import FederalBridgeFormula from 'src/federal_bridge_formula'
import AxlesWeightCheck from 'src/axles_weight_check'

window.jQuery = $;
window.App ||= {};
window.App.data ||= {};
window.FederalBridgeFormula = FederalBridgeFormula;
window.AxlesWeightCheck = AxlesWeightCheck;
